// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--lh3EL","text-wrapper":"a10a3f92e9--text-wrapper--FWhf5","icon-wrapper":"a10a3f92e9--icon-wrapper--SeJ9p"};